import { invoke } from '@shared/easyfy.decorators';
import { globalEvent } from '@shared/easyfy.core';
import { show } from '@shared/easyfy.utils';

namespace Easyfy.Modules {
  @invoke
  export class MiniBasket {

    constructor() {

    }

    onInit() {

      globalEvent({
        type: 'click',
        event: {
          action: 'toggle-mini-basket',
          callback: MiniBasket.onToggleMiniBasket
        }
      });

    }

    static onToggleMiniBasket(e) {
      e.preventDefault();

      let element = e.target as HTMLElement;

      if (element.getAttribute("data-target") == null) {
        element = element.closest('[data-target="mini-basket"]');
      }

      const miniBasket = document.querySelector('[data-container="' + element.attributes["data-target"]?.value + '"]');
      show(miniBasket)
      const createOverlayElement: HTMLElement = document.createElement("div");
      createOverlayElement.setAttribute('data-overlay-container', '');
      createOverlayElement.className = 'overlay';

      document.body.appendChild(createOverlayElement);
    }
  
  }
}

export default Easyfy.Modules;